<template>
    <el-badge style="height: 32px; margin-right: 60px; cursor: pointer;">
        <el-tooltip class="item" effect="dark" :content="`设备状态`" placement="top-start">
            <el-popover placement="bottom-start" width="230" trigger="click">
                <div slot="default">
                    <div :class="['device-view-div', item.status === '1'? 'success':'failure']"
                         v-for="item in data" @click="handleViewInfo(item)"
                         :key="item.uuid">
                        <el-card class="box-card" shadow="hover">
                            <div class="device-view-div-body">
                                <p class="status">{{ item.status === '1' ? '运行正常' : '运行异常' }}</p>
                                <p class="name">{{ item.name }}</p>
                                <p class="type">{{ item.type }}</p>
                            </div>
                        </el-card>
                    </div>
                </div>
                <DeviceIcon slot="reference" :normal="!data.some(v=> v.status === '0')"></DeviceIcon>
            </el-popover>
        </el-tooltip>

        <el-dialog close-on-press-escape append-to-body v-draggable :title="'设备信息 - ' + info.data.name" :visible.sync="info.visible"
                   width="600px">
            <div class="dialog-button">
                <el-button title="初始化" class="green" icon="el-icon-magic-stick">初始化</el-button>
                <el-button title="刷新" class="blue" icon="el-icon-refresh">刷新</el-button>
            </div>
            <div v-if="info.visible">
                <el-form label-position="top">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="设备名称" v-if="info.data.name">
                                <el-input v-model="info.data.name" readonly></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="设备类型" v-if="info.data.type">
                                <el-input v-model="info.data.type" readonly></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="设备状态" v-if="info.data.statusInfo">
                                <el-input v-model="info.data.statusInfo" readonly></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="设备地址" v-if="info.data.address">
                                <el-input v-model="info.data.address" readonly></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="设备网络" v-if="info.data.netStatus">
                                <el-input v-model="info.data.netStatus" readonly></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="连接池大小" v-if="info.data.poolSize">
                                <el-input v-model="info.data.poolSize" readonly></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="设备日志地址" v-if="info.data.logPath">
                                <el-input v-model="info.data.logPath" readonly></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="IC卡企业名称" v-if="info.data.entName">
                                <el-input v-model="info.data.entName" readonly></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="IC卡号" v-if="info.data.number">
                                <el-input v-model="info.data.number" readonly></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item label="异常信息" v-if="info.data.exception">
                        <el-input v-model="info.data.exception" type="textarea" :rows="7" readonly></el-input>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>

    </el-badge>
</template>

<script>
import ajax from "@/libs/Ajax";
import DeviceIcon from "./DeviceIcon.vue";

let NAME_SPACE = "";
let doQuery = params => {
    return ajax.get(`${NAME_SPACE}/query`, {params});
}
export default {
    components: {DeviceIcon},
    data: () => ({
        info: {
            visible: false,
            data: {}
        },
        data: [
            {
                uuid: '1',
                name: 'IC卡加密',
                type: 'ukey',
                status: '1',
                statusInfo: '运行正常',
                address: '',
                netStatus: '',
                poolSize: '',
                logPath: '',
                entName: '这是一个比较长的企业名有限公司',
                number: '8950000085008',
                exception: '异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息',
            },
            {
                uuid: '2',
                name: '三未加密机',
                type: 'sanwei',
                status: '1',
                statusInfo: '运行正常',
                address: '加密机ip地址:端口',
                netStatus: '通畅',
                poolSize: '20',
                logPath: 'd:/logs/sanwei.log',
                entName: '',
                number: '',
                exception: '异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息',
            },
            {
                uuid: '3',
                name: '世纪新安加密机',
                type: 'shijixinan',
                status: '0',
                statusInfo: '运行异常',
                address: '加密机ip地址:端口',
                netStatus: '通畅',
                poolSize: '',
                logPath: '',
                entName: '',
                number: '',
                exception: '异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息异常信息',
            }
        ]
        // pageTable: new PageTable({
        //     doLoad: doQuery,
        //     autoLoad: true
        // }),
    }),
    methods: {
        handleViewInfo(item) {
            this.info.data = item;
            this.info.visible = true;
        }
    }
}
</script>

<style lang="scss" scoped>
$success-color: #0e932e;
$failure-color: #d81e06;
svg {
    height: 30px;
    width: 30px;
}

.success {
    .el-card {
        border-left: 4px solid $success-color !important;
    }

    .status {
        background-color: $success-color;
    }
}

.failure {
    .el-card {
        border-left: 4px solid $failure-color !important;
    }

    .status {
        background-color: $failure-color;
    }
}

.device-view-div:nth-last-child(1) {
    margin-bottom: 0;
}

.device-view-div {
    margin-bottom: 10px;

    p {
        margin: 0;
    }

    .el-popover {
        padding-bottom: 0 !important;
    }

    .el-card {
        cursor: pointer;
    }

    .device-view-div-body {
        padding: 3px;

        .status {
            float: right;
            height: 22px;
            font-size: 12px;
            width: 61px;
            text-align: center;
            line-height: 22px;
            color: #fff;
        }
    }
}
</style>